import { render, staticRenderFns } from "./EchartsThree.vue?vue&type=template&id=2b50896d&scoped=true&"
import script from "./EchartsThree.vue?vue&type=script&lang=js&"
export * from "./EchartsThree.vue?vue&type=script&lang=js&"
import style0 from "./EchartsThree.vue?vue&type=style&index=0&id=2b50896d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50896d",
  null
  
)

export default component.exports